import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="mt-32 border-t"
      style={{ borderColor: "var(--line)", background: "var(--surface-alt)" }}
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif-display text-3xl" style={{ color: "var(--forest)" }}>
            Humming<span style={{ color: "var(--terracotta)" }}>Stayz</span>
          </div>
          <p className="mt-4 text-sm max-w-md" style={{ color: "var(--text-2)" }}>
            Premium long-stay homes for modern travelers. Curated spaces with thoughtful add-ons that make a month feel like home.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Marketplace</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/listings" className="hover:text-[color:var(--forest)]">Browse stays</Link></li>
            <li><Link to="/dashboard" className="hover:text-[color:var(--forest)]">Become a host</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-2)" }}>
            <li>contact@hummingstayz.com</li>
            <li>Kharghar, Navi Mumbai</li>
          </ul>
        </div>
      </div>
      <div className="px-6 lg:px-10 py-6 text-xs flex items-center justify-between" style={{ color: "var(--text-3)" }}>
        <span>© {new Date().getFullYear()} HummingStayz</span>
        <span>Made in India.</span>
      </div>
    </footer>
  );
}
